/**
 * `NumLabel` — mono uppercase kicker with a zero-padded step number.
 * Same shape as the dashboard's atom.
 */

import type { ReactNode } from 'react';

import { useC } from '../../lib/theme.js';

const monoFont = "'JetBrains Mono', monospace";

export interface NumLabelProps {
  n: number;
  children: ReactNode;
}

export function NumLabel({ n, children }: NumLabelProps): JSX.Element {
  const C = useC();
  return (
    <div className="flex items-center gap-3 mb-6">
      <span style={{ fontFamily: monoFont, color: C.dim, fontSize: 11, letterSpacing: 1 }}>
        {String(n).padStart(2, '0')} —
      </span>
      <span
        style={{
          fontFamily: monoFont,
          color: C.muted,
          fontSize: 11,
          letterSpacing: 2,
          textTransform: 'uppercase',
        }}
      >
        {children}
      </span>
    </div>
  );
}
